import { observer } from 'mobx-react';
import { QuadroViewLayout } from './quadroLayout/QuadroViewLayout';

export enum ViewLayouts {
  SINGLE = 1,
  DOUBLE = 2,
  QUADRO = 4
}

export interface ViewLayoutConfigurationProvider {
  getLayout: () => ViewLayouts;
}

export const ViewLayout: React.FC = observer(() => {
  return <QuadroViewLayout />;
});
